import Script from 'next/script';

/* eslint-disable jsx-a11y/alt-text */
const FACEBOOK_ID = 407385466095156;

const script = `
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', ${FACEBOOK_ID});
`;

export default function Facebook(): JSX.Element {
  return (
    <>
      <Script
        id="facebook-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{ __html: script }}
      />
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src={`https://www.facebook.com/tr?id=${FACEBOOK_ID}&ev=PageView&noscript=1`}
        />
      </noscript>
    </>
  );
}
